import {
  GET_PERSONNELS,
  GET_PERSONNELS_SUCCESS,
  GET_PERSONNELS_FAILURE,
  ADD_PERSONNEL,
  ADD_PERSONNEL_SUCCESS,
  ADD_PERSONNEL_FAILURE,
  DELETE_PERSONNEL,
  DELETE_PERSONNEL_SUCCESS,
  DELETE_PERSONNEL_FAILURE,
  GET_SINGLE_PERSONNEL,
  GET_SINGLE_PERSONNEL_SUCCESS,
  GET_SINGLE_PERSONNEL_FAILURE,
  CHANGE_AVAILABILITY_STATUS,
  CHANGE_AVAILABILITY_STATUS_SUCCESS,
  CHANGE_AVAILABILITY_STATUS_FAILURE,
} from "./actionTypes";

const initialState = {
  personnels: [],
  loading: false,
  error: "",
  singlePersonnel: {},
};

const brands = (state = initialState, action) => {
  switch (action.type) {
    case GET_PERSONNELS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case GET_PERSONNELS_SUCCESS:
      state = {
        ...state,
        loading: false,
        personnels: action.payload.personnels,
      };
      break;
    case GET_PERSONNELS_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case GET_SINGLE_PERSONNEL:
      state = {
        ...state,
        loading: true,
      };
      break;

    case GET_SINGLE_PERSONNEL_SUCCESS:
      state = {
        ...state,
        loading: false,
        singlePersonnel: action.payload.personnel,
      };
      break;

    case GET_SINGLE_PERSONNEL_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
        singlePersonnel: {},
      };
      break;

    case ADD_PERSONNEL:
      state = {
        ...state,
        loading: true,
      };
      break;
    case ADD_PERSONNEL_SUCCESS:
      state = {
        ...state,
        loading: false,
        personnels: action.payload.personnels,
      };
      break;
    case ADD_PERSONNEL_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    case DELETE_PERSONNEL:
      state = {
        ...state,
        loading: true,
      };
      break;
    case DELETE_PERSONNEL_SUCCESS:
      const countriesAfterDeleteing = [
        ...state?.personnels?.filter(
          (country) => country?.id !== action.payload,
        ),
      ];
      state = {
        ...state,
        loading: false,
        personnels: countriesAfterDeleteing,
      };
      break;
    case DELETE_PERSONNEL_FAILURE:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;

    case CHANGE_AVAILABILITY_STATUS:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CHANGE_AVAILABILITY_STATUS_SUCCESS:
      state = {
        ...state,
        loading: false,
        personnels: state.personnels.map((personnel) => {
          if (personnel.id === action.payload.personnel.id) {
            return {
              ...personnel,
              available: action.payload.personnel.available,
            };
          }
          return personnel;
        }),
      };
      break;
    case CHANGE_AVAILABILITY_STATUS_FAILURE:
      state = { ...state, error: action.payload, loading: false };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default brands;
